angular.module('admin.services')

.factory('MailtoService', ['Dictionary', 'HelperService', '$filter', function(Dictionary, helpers, $filter){

  function createPreferredReaCmaRequest(options){
    options = Object.assign({dictionary: new Dictionary(), helpers, $filter}, options);
    return new PreferredReaCmaRequest(options);
  }

  function createRecommendedReaCmaRequest(options){
    options = Object.assign({dictionary: new Dictionary(), helpers, $filter}, options);
    return new RecommendedReaCmaRequest(options);
  };

  function createMlsProInvite(options){
    options = Object.assign({dictionary: new Dictionary(), helpers, $filter}, options);
    return new MlsProInviteMailtoString(options);
  };

  function createSponsorAgentInvite(options){
    options = Object.assign({dictionary: new Dictionary(), helpers, $filter}, options);
    return new SponsorAgentInviteMailtoString(options);
  };

  return {
    create: function(type, options){
      if(type === 'preferredRea')
        return createPreferredReaCmaRequest(options);
      else if(type === 'recommendedRea')
        return createRecommendedReaCmaRequest(options);
      else if(type === 'mlsProInvite')
        return createMlsProInvite(options);
      else if(type === 'sponsorAgentInvite')
        return createSponsorAgentInvite(options);
    }
  };

}]);
